import { put } from '../apiRequest';
import { ClaimEditData } from './claims';

export const clientClaims = {
  edit: (data: ClaimEditData) => put('v1/ClientClaims/edit', data),
  //** at this moment no need to check for warnings for clientClaims
  // warnings: (data: ClaimEditData) => post('v1/ClientClaims/warnings', data),
  warnings: (data: ClaimEditData) => [],
};
